<div id="servicemodal" class="modal-content">
  <div
    *ngIf="showCategory && product"
    id="planInfoModal{{product.code}}"
    tabindex="-1"
  >
    <div class="modal-header-cit2">
      <div class="dismiss" (click)="bsModalRef.hide()" aria-label="Close">
        <a class="gb-icon-button" style="text-decoration: none">
          <span aria-hidden="true" class="icon-ui-close"></span>
        </a>
      </div>
    </div>
    <!-- plan modal image, name and description  -->
    <div class="modal-body modal-body-cit2">
      <img class="img-fluid plan-image" [src]="imagedisplay" />
      <div class="modal-body-cit2" *ngFor="let value of displayPlanName;">
        <!-- displayplannamebilling -->
        <div class="gb-headline1 mb-5 plan-name-header">{{value.code}}</div>
        <!-- planCode -->
        <div class="gb-body1 mb-5 plan-description">{{replaceBrand(value.description, (activeVehicle$ | async)?.make)}}</div>
        <div class="gb-body2 mb-4"></div>
        <ul class="modal-controls-cit2">
          <ng-container>
            <li
              (click)="goToService(value,item.name,i)"
              class="newclass"
              *ngFor="let item of value.features; let i=index"
            >
              <div class="gb-body1 heavy category-name">
                {{ replaceBrand( item.name, (activeVehicle$ | async)?.make ) }}
              </div>
              <div class="float-right d-flex">
                <button class="btn-icn icon-dummy_profile btn-acc btn-log">
                  <span aria-hidden="true" class="icon-ui-arrowright"> </span>
                </button>
              </div>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
  <div *ngIf="showsubCategory && (secondmodalcontent || newStorageArray?.length)">
    <div class="modal-header-cit2">
      <div class="back-dismiss">
        <!-- previous button and heading, of second modal  -->
        <div class="back back-dismiss" *ngIf="previousbtn">
          <div (click)="resetView()">
            <a
              class="gb-icon-button pl-0"
              style="text-decoration: none"
              tabindex="0"
            >
              <span aria-hidden="true" class="icon-ui-arrowleft"></span>
            </a>
          </div>
          <div class="gb-body1 heavy feature-name-header back-dismiss">
            {{displayPlanName[0].code}}
          </div>
        </div>
        <div
          *ngIf="subcategoryclosebtn"
          class="dismiss"
          (click)="bsModalRef.hide()"
          aria-label="Close newpopup"
        >
          <a
            class="gb-icon-button"
            style="text-decoration: none"
            (keyup.enter)="bsModalRef.hide()"
            tabindex="0"
          >
            <span aria-hidden="true" class="icon-ui-close pr-0"></span>
          </a>
        </div>
      </div>
    </div>
    <!-- second modal view while clicking particular service -->
    <div style="height: auto" *ngIf="secondmodalcontent && newStorageArray?.length">
      <carousel
        [noWrap]="false"
        [showIndicators]="showIndicator"
        [(activeSlide)]="activeSlide"
        (activeSlideChange)="change($event)"
        [interval]="0"
      >
        <slide class="p-0" *ngFor="let feature of newStorageArray;">
          <div *ngIf="feature">
            <img alt="image slide" src="{{feature.image}}" />
            <div
              class="modal-title gb-headline1 mb-3 pl-9 pr-9 mt-8"
              id="exampleModalLabel"
            >
              {{ replaceBrand(feature.name, (activeVehicle$ | async)?.make ) }}
            </div>
            <p class="gb-body1 pl-9 pr-9 pb-3">
              {{ replaceBrand(feature.description, (activeVehicle$ | async)?.make
              ) }}
            </p>
          </div>
        </slide>
      </carousel>
      <br />
      <div></div>
    </div>
    <!-- direct modal component  -->
    <div *ngIf="mainmodalcontent && newStorageArray?.length">
      <div class="mt-3" style="height: auto">
        <carousel
          [noWrap]="false"
          [showIndicators]="showIndicator"
          [(activeSlide)]="activeSlide"
          (activeSlideChange)="change($event)"
          [interval]="0"
        >
          <slide *ngFor="let feature of newStorageArray;">
            <div *ngIf="feature">
              <img alt="image slide" src="{{feature.image}}" />
              <div
                class="modal-title gb-headline1 mb-3 pl-6 mt-4 pr-9"
                id="exampleModalLabel"
              >
                {{ replaceBrand(feature.name, (activeVehicle$ | async)?.make ) }}
              </div>
              <p class="gb-body1 pr-9 pl-6 pb-3 pb-8">
                {{ replaceBrand(feature.description, (activeVehicle$ |
                async)?.make ) }}
              </p>              
            </div>
          </slide>
        </carousel>
        <br />
        <div></div>
      </div>
    </div>
  </div>
</div>